import { BaseReplyDTO } from './BaseReply';

export class CheckSubscriptionDto extends BaseReplyDTO{
    customerRef: number = 0;
    subscriptionUpgraded: boolean = false;
    planSlots: number = 0;
    daysRemain: number = 0;
    isNewPurchase: boolean = false;
}